import React, {forwardRef} from "react";
import cx from "../cx";
import {documentStyles as styles} from "./document.css";

type DocumentProps = {
  size?: keyof typeof styles.bySize;
  colorfulHeadings?: boolean;
  className?: string;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLDivElement>; // Add HTMLAttributes to allow standard HTML attributes

const Document = forwardRef<HTMLDivElement, DocumentProps>(
  ({size = "md", className, children, colorfulHeadings, ...rest}, ref) => (
    <div
      className={cx(
        className,
        styles.base,
        styles.bySize[size],
        colorfulHeadings && styles.testStyle
      )}
      dir="auto"
      {...rest}
      ref={ref}
    >
      {children}
    </div>
  )
);

export default Document;
